
import { useSyncExternalStore } from "react";
import AuthenticationService from "..";

const getSnapshot = () => {
    return AuthenticationService.getReactSnapshot();
}

const subscribe = (callback) => {
    return AuthenticationService.subscribeReact(callback);
}

const checkCredentials = async (signedToken) => {
    if(signedToken) {
        return AuthenticationService.checkLoginSignedToken(signedToken);
    }
    return AuthenticationService.checkCredentials();
}

const login = async ({ email, password }) => {
    return AuthenticationService.login({ email, password });
}

const getResourceToken = async () => {
    return AuthenticationService.getResourceTokenQueryString();
}

const logout = async ({ onlyRemoveToken = false }) => {
    return AuthenticationService.logout({ onlyRemoveToken });
}

const removeSpecialTokens = async ({ type = undefined }) => {
    return AuthenticationService.removeSpecialTokens({ type });
}

const resetEverything = async () => {
    return AuthenticationService.resetEverything();
}



export default function useAuthentication() {
    const { authenticated, authenticationMethod, setupRequired, tokens, progressive, communicationMethod, hasPasskey, authenticationToken, error, userInfo } = useSyncExternalStore(subscribe, getSnapshot);

    return {
        authenticated, 
        checkCredentials, 
        authenticationMethod, 
        login, setupRequired, 
        tokens, getResourceToken, 
        progressive, logout, 
        communicationMethod, 
        hasPasskey, 
        authenticationToken, 
        removeSpecialTokens, 
        resetEverything,
        error,
        userInfo
    }
}